// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "flickity" + "." + "279a639d8cc5149c8721" + ".js";
};